import { render, staticRenderFns } from "./Emitter.vue?vue&type=template&id=dee68aba&scoped=true&"
import script from "./Emitter.vue?vue&type=script&lang=js&"
export * from "./Emitter.vue?vue&type=script&lang=js&"
import style0 from "./Emitter.vue?vue&type=style&index=0&id=dee68aba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee68aba",
  null
  
)

export default component.exports